import { h, Component } from 'preact';
import dlv from 'dlv';
import cx from 'classnames';

import style from './style';
import pageStyles from '../../pageStyles';

import SimpleGridCluster from '../../../clusters/simple-grid-cluster';
import { TopBorder } from '../../../pieces/top-border';
import { SadlibAd } from '../../../pieces/sadlib-ad';
import { TaboolaJs } from '../../../pieces/taboola-js';
import { VideoPlayer } from '../../../pieces/video-player';
import { Header, Footer } from '../../shared/desktop';
import { getCommonProps } from '../../../../lib/page';
import { getImageSrc } from '../../../../lib/image';

import { ColumnSticky, Column, Row, Section, ContainerFluid } from '@cube/layout';
import { Icon } from '@cube/blocks';
import { trackProps, getTrackingAttributesForAsset } from '@cube/track';
import { assetLink } from '@cube/utils';


export class Desktop extends Component {

	sideVariantPlaylist = (videos) => (
		<div class={style.sideVariantPlaylist}>
			<div class={style.playlist}>
				{ videos && videos.map((video, index) => {
					let thumbnail = getImageSrc(video.images, 'w=300,h=169');

					return (
						<a
							{...trackProps(getTrackingAttributesForAsset(video), this.context)}
							href={assetLink(video)}
							class={style.card}
						>
							{ thumbnail ?
								<img class={style.thumbnail} src={thumbnail} /> :
								<div class={style.noThumbnail}  />
							}
							<span class={style.content}>
								<div class={style.title}>{video.title}</div>
							</span>
							<div class={style.icon}>
								<Icon name="play-cube" />
							</div>
						</a>
					);
				})}
			</div>
		</div>
	);

	render({ relatedVideos, pageConfig, browseCategories, shuffledCategories, playlistMode, ...props }) {
		return (
			<ContainerFluid class={pageStyles.fluidPageNoPadding}>
				<Header
					pageConfig={pageConfig}
					adId="sc_readvideo_header_banner"
					{...props}
				/>
				{ playlistMode === 'side' &&
					<Section key="side" rowClass={style.heroRow} containerClass={pageStyles.defaultPageWidth}>
						<Row>
							<Column>
								<div class={style.videoHero}>
									<div class={style.container}>
										<div class={style.videoWrapper}>
											<div class={style.aspectWrapper}>
												<div class={style.playerWrapper}>
													<VideoPlayer {...props} />
												</div>
											</div>
										</div>
										{this.sideVariantPlaylist(relatedVideos)}
									</div>
								</div>
							</Column>
						</Row>
					</Section>
				}
				<Section key="notside" containerClass={pageStyles.defaultPageWidth}>
					<Row>
						<Column class={cx(pageStyles.fixedLeftColumn, style.dmColumn)}>
							{ playlistMode === 'below' &&
								<div class={style.videoHero}>
									<div class={style.container}>
										<div class={style.videoWrapper}>
											<div class={style.aspectWrapper}>
												<div class={style.playerWrapper}>
													<VideoPlayer {...props} />
												</div>
											</div>
										</div>
									</div>
								</div>
							}
							<SadlibAd id="sc_readvideo_trailers_banner" type="desktopBanner" restrictWidth />
							<div>
								{ relatedVideos && playlistMode === 'below' &&
									[
										<TopBorder />,
										<SimpleGridCluster
											title="Related Videos"
											imageRole="w=300,h=169"
											rowCount={2}
											columnCount={3}
											assets={relatedVideos}
										/>
									]
								}
							</div>
							{
								shuffledCategories && shuffledCategories.map((category, i) => i < dlv(pageConfig, 'clusters.randomDailyMotion.count') && (
									[
										<TopBorder />,
										<SimpleGridCluster
											{...browseCategories[shuffledCategories[i]]}
											{...dlv(pageConfig, 'clusters.randomDailyMotion.clusterProps')}
											isDailyMotion
											{...getCommonProps(props)}
										/>
									]
								))
							}
							<SadlibAd id="sc_readvideo_news_banner" type="desktopBanner" restrictWidth />
							<TopBorder />
							<TaboolaJs {...dlv(pageConfig, 'taboola.bottomPage')} class={style.taboolaFiniteFeedVideo} qeId="sc-readvideo-taboola-bottompage" />
						</Column>
						<ColumnSticky class={pageStyles.fixedRightColumn}>
							<SadlibAd id="sc_readvideo_sidebar_top" type="desktopRail" />
							<TopBorder />
							<TaboolaJs {...dlv(pageConfig, 'taboola.rightRail')} qeId="sc-readvideo-youmayalsolike" />
							<SadlibAd id="sc_readvideo_sidebar_middle" type="desktopRail" />
							<TopBorder />
							<SimpleGridCluster
								{...dlv(pageConfig, 'clusters.recommended')}
								qeId="sc-readvideo-recommended"
								{...getCommonProps(props)}
							/>
							<SadlibAd id="sc_readvideo_sidebar_bottom" type="desktopRail" />
						</ColumnSticky>
					</Row>
				</Section>
				<Footer
					pageConfig={pageConfig}
					{...getCommonProps(props)}
				/>
			</ContainerFluid>
		);
	}
}
